import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { loadingMiddleware } from './middleware/loadingMiddleware';
import groupCustumerSlice from './slices/groupCustumerSlice';
import infoUserSlice from './slices/infoUserSlice';
import loadingReducer from './slices/loadingSlice';
import menuSlice from './slices/menuSlice';
import permissionSlice from "./slices/permissionSlice";
import toastReducer from './slices/toastSlice';
import unitByUserPermissionSlice from "./slices/UnitByUserPermission";
import userReducer from './slices/userSlice';
import categoryCarSlice from './slices/categoryCarSlice';
import sourceColumnWarehouseSlice from './slices/sourceColumnWarehouseSlice';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    "dataAcccount", "infoUserSlice", "menuSlice", "permissionSlice",
    "unitByUserPermissionSlice", "dataPermissionCustomerSlice", "groupCustumerSlice", "categoryCarSlice", "sourceColumnWarehouseSlice"
  ]
}

const rootReducer = combineReducers({
  infoUserSlice: infoUserSlice,
  dataAcccount: userReducer,
  notifications: toastReducer,
  loading: loadingReducer,
  menuSlice: menuSlice,
  permissionSlice: permissionSlice,
  unitByUserPermissionSlice: unitByUserPermissionSlice,
  groupCustumerSlice: groupCustumerSlice,
  categoryCarSlice: categoryCarSlice,
  sourceColumnWarehouseSlice: sourceColumnWarehouseSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(loadingMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
export default store;
